export enum NotificationType {
	Deposit = 1,
	Withdrawal = 2,
	Send = 3,
	Receive = 4,
	Exchange = 5,
	Point = 6,
	Voucher = 7,
	RequestMessage = 8,
	Ticket = 9,
	ExpertTicket = 10,
	Friend = 11,
	ContactUs = 12,
	VerifyInfo = 13,
	VerifyBankAccount = 14,
	WalletChange = 15,
	DirectDeposit = 18,
	PointChange = 16,
	P2P = 19,
	Crypto = 20,
	CryptoWithdraw = 21,
	Chat = 22,
}
